export const routes = [
  ...require('./vehicle/routes').routes,
  ...require('./organizational-structure/routes').routes,
  ...require('./person/routes').routes,
  ...require('./user/routes').routes,
  ...require('./products-tax/routes').routes,
  ...require('./profile/routes').routes,
  ...require('./generator/routes').routes,
  ...require('./carrier/routes').routes,
  ...require('./structure/routes').routes,
  ...require('./client/routes').routes,
  ...require('./billing/routes').routes,
  ...require('./address/routes').routes,
  ...require('./landfill-management/routes').routes,
  ...require('./integration/routes').routes,
  ...require('./consent-letter/routes').routes,
  ...require('./balance/routes').routes,
  ...require('./mtr/routes').routes,
  ...require('./ticket/routes').routes,
  ...require('./contract/routes').routes,
  ...require('./order/router').routes,
  ...require('./consumer-unit/routes').routes,
  ...require('./control-batch-report/router').routes,
  ...require('./attendance/router').routes,
  ...require('./concession/routes').routes,
  ...require('./concession-contract/routes').routes,
  ...require('./concession-dashboard/router').routes,
  ...require('./unsynced-message/routes').routes,
  ...require('./report/weighing/technology-dashboard/router').routes,
  ...require('./report/weighing/annual-weighing/router').routes,
  ...require('./technical-assessment/routes').routes,
  ...require('./transshipment/routes').routes,
  ...require('./industry/routes').routes,
  ...require('./industry/industrial-integration-error/routes').routes,
  ...require('./danfe/routes').routes,
  ...require('./concession/agreement-report/routes').routes,
  ...require('./concession/invoice-exempt-cancelled/routes').routes,
  ...require('./concession/service-report/routes').routes,
  ...require('./industry/industrial-map/routes').routes,
  ...require('./contract-item-cost-center/routes').routes
]
